import React from "react";
import { ShieldCheck, Tag, Star, Headphones } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, title: "Best Price Guarantee", desc: "Found a better price? We'll match it." },
  { icon: Tag, title: "Free Cancellation", desc: "Plans change. We've got you." },
  { icon: Star, title: "Top Rated Suppliers", desc: "Trusted brands. Quality you can count on." },
  { icon: Headphones, title: "24/7 Support", desc: "Real people. Anytime, anywhere." },
];

export default function TrustBar() {
  return (
    <section className="bg-white py-8 border-b border-muted">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {ITEMS.map((item) => {
            const Icon = item.icon;
            return (
              <div key={item.title} className="flex items-start gap-3">
                <div className="mt-0.5 bg-primary-soft p-2 rounded-full flex-shrink-0">
                  <Icon size={22} className="text-primary" />
                </div>
                <div>
                  <p className="font-heading font-semibold text-sm text-foreground">{item.title}</p>
                  <p className="font-body text-xs text-text-muted mt-0.5">{item.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
